/* @flow */

import './Shop.scss';
import * as React from 'react';
import { useCallback, useEffect } from 'react';
import Bullet from './Bullet';
import Footer from './Footer';
import Header from './Header';
import { Localizer } from '../helpers/localizer';
import StripeBuyButton from './StripeBuyButton';
import azelina1 from '../assets/images/shop/azelina_190.png';
import azelina2 from '../assets/images/shop/azelina_379.png';
import azelina3 from '../assets/images/shop/azelina_569.png';
import azelina4 from '../assets/images/shop/azelina_758.png';
import bookCover from '../assets/images/shop/book-cover_247.png';
import clsx from 'clsx';
import { useSelector } from 'react-redux';

const PAGE_WIDTH_THRESHOLD = 500;

const Shop = (): React.Node => {
  useSelector((state) => state.language);

  const [currentIndex, setCurrentIndex] = React.useState<number>(0);
  const [windowWidth, setWindowWidth] = React.useState<number>(typeof window !== 'undefined' ? window.innerWidth : 0);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleBulletOnClick = useCallback((index: number) => {
    setCurrentIndex(index);
  }, []);

  const covers = [bookCover];

  return (
    <div
      className='page page-shop'
      id='top'>
      <Header />

      <div className='page-shop__section page-shop__book'>
        <div className='page-shop__background' />
        <div className='page-shop__description'>
          <div className='page-shop__title'>{Localizer.localize('shop.part_1.title')}</div>
          <div className='page-shop__author'>{Localizer.localize('shop.part_1.author')}</div>
          <div className='page-shop__foreword'>{Localizer.localize('shop.part_1.foreword')}</div>
          <div className='page-shop__synopsis'>{Localizer.localize('shop.part_1.synopsis')}</div>
          <div className='page-shop__tagline'>{Localizer.localize('shop.part_1.tagline')}</div>
          <div className='page-shop__buy-wrapper'>
            <div className='page-shop__price'>17&nbsp;€</div>
            <StripeBuyButton isLight={windowWidth > PAGE_WIDTH_THRESHOLD} />
          </div>
        </div>
      </div>

      <div className='page-shop__section page-shop__teasing'>
        <div className='page-shop__teasing-wrapper'>
          <div className='page-shop__teasing-title'>{Localizer.localize('shop.part_2.title')}</div>
          <div>{Localizer.localize('shop.part_2.text')}</div>
        </div>
        <div className='page-shop__foreword-wrapper'>
          <div>{Localizer.localize('shop.part_2.foreword_citation')}</div>
          <div>{Localizer.localize('shop.part_2.foreword_author')}</div>
        </div>
      </div>

      <div className='page-shop__section page-shop__author-section'>
        <img
          alt="Photo d'Azélina Jaboulet-Vercherre"
          sizes='(max-width: 600px) 190px, (max-width: 900px) 379px, (max-width: 1400px) 569px, 758px'
          src={azelina4}
          srcSet={`${azelina1} 190w, ${azelina2} 379w, ${azelina3} 569w, ${azelina4} 758w`} />
        <div className='page-shop__about'>
          <div className='page-shop__about_title'>{Localizer.localize('shop.part_3.about_author')}</div>
          <div className='page-shop__about_bio'>{Localizer.localize('shop.part_3.author_bio')}</div>
        </div>
      </div>

      <div className='page-shop__section page-shop__book-egon-editions'>
        <div className='page-shop__book-cover-details'>
          <div className='book-cover-wrapper'>
            {/* eslint-disable react/no-array-index-key */}
            <div className='book-cover__images'>
              {covers.map((cover, index) => (
                <img
                  alt=''
                  className={clsx('book-cover__image', index === currentIndex && 'visible')}
                  key={`cover-img-${index}`}
                  src={cover} />
              ))}
            </div>
            <div className='book-cover__carousel'>
              {covers.length > 1 ? covers.map((_, index) => <Bullet
                index={index}
                isFull={index === currentIndex}
                isLight={false}
                key={`cover-bullet-${index}`}
                onClick={handleBulletOnClick} />) : null}
            </div>
            {/* eslint-enable react/no-array-index-key */}
          </div>
          <div className='page-shop__book-details'>
            <div className='book-details__title'>{Localizer.localize('shop.part_4.the_book')}</div>
            <div className='book-details__info'>{Localizer.localize('shop.part_4.book_details')}</div>
            <div className='book-details__tagline'>{Localizer.localize('shop.part_4.read_offer_share')}</div>
            <div className='book-details__price'>17&nbsp;€</div>
            <StripeBuyButton isLight={false} />
          </div>
        </div>
        <div className='page-shop__egon-table'>
          <div className='egon-table__title'>{Localizer.localize('shop.part_4.egon_table_title')}</div>
          <div className='egon-table__paragraph'>{Localizer.localize('shop.part_4.egon_table_paragraph1')}</div>
          <div className='egon-table__paragraph'>{Localizer.localize('shop.part_4.egon_table_paragraph2')}</div>
          <div
            className='egon-table__paragraph final-paragraph'>{Localizer.localize('shop.part_4.egon_table_paragraph3')}</div>
          <div
            className='egon-table__paragraph contact'>
            <span>{Localizer.localize('shop.part_4.contact')}</span>
            <a
              href='mailto:egon@egonparis.com'
              rel='noopener noreferrer'
              target='_blank'>egon@egonparis.com</a>
          </div>
        </div>
      </div>

      <div className='page-shop__section page-shop__book-zoom' />

      <Footer />
    </div>
  );
};

export default Shop;
